export default "__VITE_ASSET__xYULTU9n__"